import * as actionTypes from './actionTypes';

export const addMixBet=(bet)=>({
    type:actionTypes.ADD_MIX_BET,
    payload:bet
})